class OrderModel {
    booking_date: string; //预约时间
    cancel_reason: string;
    cancel_time: string;
    complete_time: string;//核销时间
    contact_email: string;
    contact_zone: string; //电话区号
    contact_mobile: string; //电话号码
    contact_name: string;
    created_at: string;
    end_time: string; //时段结束时间
    id: number;
    no_show_time: string;
    order_sn: string;
    pay_time: string;
    resource_type: number;
    slot_id: number; //时段ID
    start_time: string; //时段开始时间
    status: number; //订单状态：1-已支付(待核销)，2-已完成，3-已取消，4-爽约(未到)
    updated_at: string;
    user_id: number; //用户ID-前端存起来，后面要用
    go_out_complete_time:string;//出门时间
    visitor_count:string;//访客人数
    appointment_code:string;
    appointment_name:string;
    constructor(data: Record<string, any> | undefined) {
        this.booking_date = data?.booking_date || '';
        this.cancel_reason = data?.cancel_reason || '';
        this.cancel_time = data?.cancel_time || '';
        this.complete_time = data?.complete_time || '';
        this.contact_email = data?.contact_email || '';
        this.contact_zone = data?.contact_zone || '';
        this.contact_mobile = data?.contact_mobile || '';
        this.contact_name = data?.contact_name || '';
        this.created_at = data?.created_at || '';
        this.end_time = data?.end_time || '';
        this.id = data?.id || 0;
        this.no_show_time = data?.no_show_time || '';
        this.order_sn = data?.order_sn || '';
        this.pay_time = data?.pay_time || '';
        this.resource_type = data?.resource_type || 0;
        this.slot_id = data?.slot_id || 0;
        this.start_time = data?.start_time || '';
        this.status = data?.status || 0;
        this.updated_at = data?.updated_at || '';
        this.user_id = data?.user_id || 0;
        this.go_out_complete_time = data?.go_out_complete_time || '';
        this.visitor_count = data?.visitor_count || '';
        this.appointment_name = data?.appointment_name || '';
        this.appointment_code = data?.appointment_code || '';
    }
}
export default OrderModel;
